import React, { useState, useRef, useEffect } from 'react';
import {  X, Settings, User, LogOut } from 'lucide-react';
import {  not, userimg } from '../../assets/assets';
import { useAuthStore } from '../../store/authStore';

const UserProfile = () => {
  const { user, logout } = useAuthStore();
  const name = user ? `${user.firstName} ${user.lastName}` : 'User';
  const username = user?.username || '@user';
  const avatar = user?.profilePicture || userimg;



  return (
    <>
    <div className="bg-[#EFEEF399] dark:bg-[#1d2026] rounded-md p-4 font-['Poppins'] relative">
       

        <div className="flex flex-col items-center">
          <div className="w-14 h-14 md:w-24 md:h-24 rounded-full overflow-hidden mb-3">
            <img
              src={avatar}
              alt={`${name}'s avatar`}
              className="w-full h-full object-cover"
            />
          </div>
          <h3 className="text-[14px] md:text-lg font-medium text-gray-900 dark:text-white">{name}</h3>
          <p className="text-[12px] font-normal text-gray-500 dark:text-gray-400">{username}</p>
        </div>
      </div>

    </>
  );
};

export default UserProfile;